import React from 'react';

export interface ExecutiveMovementInsightsPanelProps {
  children: React.ReactNode;
}

/**
 * Container for YoY decliners / performers widgets (keeps the executive page layout modular).
 */
const ExecutiveMovementInsightsPanel: React.FC<ExecutiveMovementInsightsPanelProps> = ({
  children,
}) => <div style={{ marginTop: '0.25rem' }}>{children}</div>;

export default ExecutiveMovementInsightsPanel;
